<template>
    <div id="index">
          <el-row>
            <el-col :span="12">
                <div class="order-box">
                    <!-- 订单 -->
                    <el-tabs v-model="activeName" type="card" @tab-click="handleClickTab">
                        <el-tab-pane label="点餐" name="first">
                            <el-table :data="tableData" show-summary style="width: 100%">
                                <el-table-column prop="goodsName" label="商品名称" align="center" width="200px">
                                </el-table-column>
                                <el-table-column prop="count" label="数量" align="center">
                                </el-table-column>
                                <el-table-column prop="allPrice" label="总金额" align="center">
                                </el-table-column>
                                <el-table-column label="操作" fixed="right" align="center" width="200px">
                                    <template slot-scope="scope">
                                        <el-button
                                        size="mini"
                                        @click="handleAdd( scope.$index ,scope.row)">+</el-button>
                                        <el-button
                                        size="mini"
                                        type="danger"
                                        @click="handleReduce(scope.$index, scope.row)">-</el-button>
                                        <el-button
                                        size="mini"
                                        type="danger"
                                        @click="handleRemove( scope.$index ,scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <div class="btn-box">
                                <el-button type="primary" icon="el-icon-edit" @click="listOrder()">挂单</el-button>
                                <el-button type="success" icon="el-icon-edit" @click="checkOutOrder()">结账</el-button>
                                <el-button type="danger" icon="el-icon-edit" @click="removeOrder()">删除</el-button>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="挂单" name="second">挂单</el-tab-pane>
                        <el-tab-pane label="外卖" name="third">外卖</el-tab-pane>
                    </el-tabs>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="product-box">
                    <!-- 产品 -->
                    <el-container direction="vertical">
                        <el-main class="product-top">
                            <el-breadcrumb>
                                <el-breadcrumb-item>今日推荐</el-breadcrumb-item>
                            </el-breadcrumb>
                            <!-- 推荐商品 -->
                            <div class="recommendGoods-box">
                                <el-card v-for="item in recommendGoods" :key="item.goodsId" class="box-card recommendGoods-card card-hover" @click.native="addOrder($event, item)"> 
                                    <i class="icon iconfont icon-dangan" style="position:absolute;left:5px;top:5px;"></i>
                                    <div>
                                        <span><i style="font-size: 14px;">{{item.strMeal}}</i></span>
                                        <div class="bottom clearfix">
                                            <p style="font-size:12px;">
                                                起源地： <i style="font-size:14px;">{{item.strArea}}</i>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="img-box" style="height:85px;position:relative;">
                                        <div id="recommendGoods-img-hide" style="width: 100%;height:85px;position:absolute;top:0px;left:0px;background-color:white;font-size:40px;">
                                            <i class="el-icon-s-promotion" width="100"></i>
                                        </div>
                                        <img id="recommendGoods-img" :src="item.strMealThumb" style="width: 100%; display: block;">
                                    </div>
                                    <span class="foodPrice" style="font-size:14px;">￥ {{item.price}}元</span>
                                </el-card>
                                <div class="clear"></div>
                            </div>
                        </el-main>

                        <!-- 商品分类 -->
                        <el-main class="product-bottom" style="padding:0px;">
                            <!-- 占位 -->
                            <div id="details-loading-box">
                                <div class="loading1">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>

                            <el-tabs type="border-card" @tab-click="handleTabClick">
                                <el-tab-pane v-for="(pane, index) in areas" :key="index" :label="pane.strArea">
                                    <div class="details-box">
                                        <el-card v-for="item in details" :key="item.idMeal" class="details-card card-hover" @click.native="addOrder($event, item)">
                                            <!-- <span class="foodImg"><img class="detail-img" :src="item.strMealThumb" width="100"></span> -->

                                            <div class="img-box" style="height:85px;position:relative;">
                                                <div class="details-img-hide" style="display:none;width: 100%;height:85px;position:absolute;top:0px;left:0px;background-color:white;font-size:40px;" :img-link="item.idMeal">
                                                    <i class="el-icon-s-promotion" width="100"></i>
                                                </div>
                                                <img class="details-img" :src="item.strMealThumb" style="width: 100%; display: block;" @load="handleOnload()" :img-link="item.idMeal">
                                            </div>
                                            <p class="foodName" style="font-size:12px;">{{item.strMeal}}</p>
                                            <span class="foodPrice" style="font-size:14px;">￥ {{item.price}}元</span>
                                        </el-card>
                                        <div class="clearfix"></div>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </el-main>
                    </el-container>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Axios from 'axios';
export default {
    name:'index',
     data() {
        return {
            activeName: "first",
            urls:{
                random:'https://www.themealdb.com/api/json/v1/1/random.php',
                areas: 'https://www.themealdb.com/api/json/v1/1/list.php?a=list',
                categories: 'https://www.themealdb.com/api/json/v1/1/list.php?c=list',
                queryByArea: 'https://www.themealdb.com/api/json/v1/1/filter.php?a=',
                queryByCategories: 'https://www.themealdb.com/api/json/v1/1/filter.php?c='
            },
            tableData: [
                
            ],
            recommendGoods:[
                {
                    idMeal: "52956",
                    strMeal: "Chicken Congee",
                    strMealThumb: "https://www.themealdb.com/images/media/meals/1529446352.jpg",
                    price: 18
                }
            ],
            areas:[
                {
                    strArea: "热门"
                }
            ],
            details:[],
            detailsIndex:[
                {
                    idMeal: "52952",
                    strMeal: "Beef Lo Mein",
                    strArea:"Chinese",
                    strMealThumb: "https://www.themealdb.com/images/media/meals/1529444830.jpg",
                    price: 20
                },
                {
                    idMeal: "52956",
                    strMeal: "Chicken Congee",
                    strMealThumb: "https://www.themealdb.com/images/media/meals/1529446352.jpg",
                    price: 18
                },
                {
                    idMeal: "52955",
                    strMeal: "Egg Drop Soup",
                    strMealThumb: "https://www.themealdb.com/images/media/meals/1529446137.jpg",
                    price: 12
                },
                {
                    idMeal: "52942",
                    strMeal: "Roast fennel and aubergine paella",
                    strMealThumb: "https://www.themealdb.com/images/media/meals/1520081754.jpg",
                    price: 20
                },
                {
                    idMeal: "52773",
                    strMeal: "Honey Teriyaki Salmon",
                    strMealThumb: "https://www.themealdb.com/images/media/meals/xxyupu1468262513.jpg",
                    price: 18
                },
                {
                    idMeal: "52839",
                    price: 19,
                    strMeal: "Chilli prawn linguine",
                    strMealThumb: "https://www.themealdb.com/images/media/meals/usywpp1511189717.jpg"
                }
            ],
            typeGoods:[
                {
                    goodsId:1,
                    goodsImg:"https://img.4008823823.com.cn/kfcios/Version/621_626971.jpg",
                    goodsName:'香辣鸡腿堡',
                    price:18
                }, {
                    goodsId:2,
                    goodsImg:"",
                    goodsName:'田园鸡腿堡',
                    price:15
                }, {
                    goodsId:3,
                    goodsImg:"",
                    goodsName:'和风汉堡',
                    price:15
                }, {
                    goodsId:4,
                    goodsImg:"",
                    goodsName:'快乐全家桶',
                    price:80
                }, {
                    goodsId:5,
                    goodsImg:"",
                    goodsName:'脆皮炸鸡腿',
                    price:10
                }, {
                    goodsId:6,
                    goodsImg:"",
                    goodsName:'魔法鸡块',
                    price:20
                }, {
                    goodsId:7,
                    goodsImg:"",
                    goodsName:'可乐大杯',
                    price:10
                }, {
                    goodsId:8,
                    goodsImg:"",
                    goodsName:'雪顶咖啡',
                    price:18
                }, {
                    goodsId:9,
                    goodsImg:"",
                    goodsName:'大块鸡米花',
                    price:15
                }, {
                    goodsId:20,
                    goodsImg:"",
                    goodsName:'香脆鸡柳',
                    price:17
                }
            ]
        };
    },
    methods: {
        //公共方法
        //对象转化
        formatObj(mealObj){
            return {
                goodsId: mealObj.idMeal,
                goodsName: mealObj.strMeal,
                count: 1,
                price: mealObj.price,
                allPrice: mealObj.price
            }
        },
        //随机生成(10-20)
        priceRandom(){
            return Math.round(Math.random()*10)+10;
        },
        //判断某节点数组中是否含有某class
        findNodeAnimate(arr, className){
            arr.forEach( item => {
                //判断该节点是否含有class的节点
                if(item.className){
                    var flag = item.className.split(" ").some( (e,index,array)=>{
                       if(e==className){
                           //console.log("找到node")
                           item.className += " add-animation"
                           setTimeout(function () {
                                item.className = item.className.replace(" add-animation", "");
                           }, 800);
                       }
                    });
                    return true;
                }
                return false;
            });
        },

        //表格接口方法
        handleOnload(){
            // console.log(this)
            // console.log('图片加载完成!'); 
        },
        handleClickTab(tab, event) {
            console.log(tab);
        },
        //表格按键新增菜单
        handleAdd(index, row) {
            //console.log(row);
            //判断该菜是否已点餐
            var isOrdered = false;
            isOrdered = this.tableData.some( e=> e.goodsId==row.goodsId);
            if(isOrdered){
                //是则只需增加数量
                var tempArr = this.tableData.filter(e=> e.goodsId==row.goodsId);
                tempArr[0].count +=1;
                tempArr[0].allPrice += row.price;
            }else{
                //否则this.tableData新增对象
                var orderObj = this.formatObj(row);
                this.tableData.push(orderObj);
            }
            this.$notify({
                    title: '新增一份',
                    message: row.goodsName + "    +" + row.price + "元",
                    position: 'top-right'
                });
        },
        //表格按键减少菜单
        handleReduce(index, row) {
            //console.log(row);
            //判断数量是否为1
            if(row.count==1){
                //this.tableData需要去掉该对象,或者筛选出id不为他的其他全部元素
                var tempArr = this.tableData.filter(e=>e.goodsId!=row.goodsId);
                this.tableData = [];
                tempArr.forEach(element => {
                    this.tableData.push(element)
                });
            }else{
                //count-1
                var tempArr = this.tableData.filter(e=>e.goodsId==row.goodsId);
                tempArr[0].count --;
                tempArr[0].allPrice -= row.price;
            }
            this.$notify({
                    title: '减去一份',
                    message: row.goodsName + "    -" + row.price + "元",
                    position: 'top-right'
                });
        },
        //表格按键删除行
        handleRemove(index, row){
            //this.tableData需要去掉该对象,或者筛选出id不为他的其他全部元素
            var tempArr = this.tableData.filter(e=>e.goodsId!=row.goodsId);
            this.tableData = [];
            tempArr.forEach(element => {
                this.tableData.push(element)
            });
        },
        //商品分类详情切换事件
        handleTabClick(e){
            if(e.label=='热门'){
                this.details = this.detailsIndex;
                return;
            }

            //显示loading层
            var domLoading = document.getElementById('details-loading-box');
            // console.log(domLoading)
            domLoading.style.display = 'block';

            var _this = this;
            console.log("查询" + e.label + '菜品')
            Axios.get(_this.urls.queryByArea + e.label).then(res=>{
                console.log(res)
                _this.details = res.data.meals;
                //随机生成价格
                _this.details.every(item=> item.price=_this.priceRandom());

                document.getElementById('details-loading-box').style.display = 'none';
                //图片是否加载完成
                Array.prototype.forEach.call(document.getElementsByClassName('details-img'), el=>{
                    el.onload = (e)=>{
                        //console.log('图片加载完成!'); 
                        el.style.display = "none";
                    }
                } ); 
            }).catch(err=>{
                console.log(err);
                this.$notify({
                    title: '查询失败',
                    message: err,
                    position: 'bottom-right'
                });
            })
        },
        //点击card新增菜单
        addOrder(e, item){
            //console.log(e.path);
            //获取到card最外层节点
            var node = this.findNodeAnimate(e.path, "el-card");
            //判断该菜是否已点餐
            var isOrdered = false;
            isOrdered = this.tableData.some( e=> e.goodsId==item.idMeal);
            if(isOrdered){
                //是则只需增加数量
                var tempArr = this.tableData.filter(e=> e.goodsId==item.idMeal);
                tempArr[0].count +=1;
                tempArr[0].allPrice += item.price;
            }else{
                //否则this.tableData新增对象
                var orderObj = this.formatObj(item);
                this.tableData.push(orderObj);
            }
            this.$notify({
                    title: '新增一份',
                    message: item.strMeal + "    +" + item.price + "元",
                    position: 'top-right'
                });
        },

        //挂单
        listOrder(){
            console.log(this.tableData)
            var allFoods = "";
            this.tableData.forEach( item =>{
                allFoods += item.goodsName + '*' + item.count + '\n'
            })
            this.$notify({
                    title: '全部订单挂单',
                    message: allFoods,
                    position: 'top-right'
                });
        },
        //结账
        checkOutOrder(){
            console.log(this.tableData)
            var allFoods = "";
            this.tableData.forEach( item =>{
                allFoods += item.goodsName + '*' + item.count + '\n'
            })
            this.$notify({
                    title: '全部订单结账',
                    message: allFoods,
                    position: 'top-right'
                });
        },
        removeOrder(){
            this.tableData = [];
            this.$notify({
                    title: '删除全部订单',
                    message: "",
                    position: 'top-right'
                });
        }
    },
    mounted(){
        document.getElementsByClassName('order-box')[0].style.height = document.documentElement.clientHeight + 'px';
        //console.log(document.getElementById('recommendGoods-img'))
        document.getElementById('recommendGoods-img').onload = (e)=>{
            document.getElementById('recommendGoods-img-hide').style.display = "none";
        }
        this.details = this.detailsIndex;
    },
    created(){
        var _this = this;
        Axios.get(this.urls.random).then(res=>{
            console.log(res)
            _this.recommendGoods = res.data.meals;
            _this.recommendGoods.every(item=> item.price=_this.priceRandom());
        }).catch(err=>{
            this.$notify({
                    title: '查询失败',
                    message: err,
                    position: 'bottom-right'
                });
        })
        Axios.get(this.urls.areas).then(res=>{
            console.log(res.data.meals)
            _this.areas.push(...res.data.meals);
        }).catch(err=>{
            this.$notify({
                    title: '查询失败',
                    message: err,
                    position: 'bottom-right'
                });
        })
    }
}
</script>

<style>
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    
    .clearfix:after {
        clear: both
    }
    .card-hover:hover{
        border: 1px solid #409EFF;
        cursor: pointer;
    }
    .add-animation{
        animation: add-animation 0.8s ease-in-out 0s 1 normal none;
    }
    @keyframes add-animation{
        10%{
            opacity: 1;
        }
        50%{
            opacity: 0.6;
        }
        100%{
            opacity: 1;
        }
    }

    .order-box{
        border-right: 1px solid #e6e6e6;
        padding: 5px;
        min-height: 600px;
    }
    .btn-box{
        padding: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }


    .product-box{   
        padding: 5px;
        min-height: 600px;
    }
    .el-table_1_column_4{
        background-color: #EBEEF5;
    }
    .recommendGoods-box{
        overflow: hidden;
        margin:10px;
    }
    .recommendGoods-card{
        position: relative;
        float: left;
        width: 125px;
        height: 100%;
        margin-right: 20px;
        font: 12px Base;
        font-weight: 800;
        color: #909399;
    }
    .product-bottom{
        position: relative;
        overflow: hidden;
    }
    .details-box{
        min-height: 250px;
        position: relative;
    }
    .details-card{
        position: relative;
        overflow: hidden;
        height: auto;
        width: 125px;
        height: 200px;
        margin-right: 5px;
        margin-bottom: 5px;
        float: left;
        color: #909399;
    }
    .detail-img:after {
        content: "";
        height: 100%;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
    .foodPrice{
        position: absolute;
        bottom: 10px;
        left: 5px;
        color: #409EFF;
    }
    /* loading1 */
    #details-loading-box{
        position: absolute;
        top: 40px;
        left: 0px;
        height: 100%;
        width: 100%;
        z-index: 999;
        background-color: white;
        display: none;
    }
    .loading1{
        height: 60px;
        width: 80px;
        margin: 80px auto;
    }
    .loading1>div{
        display: inline-block;
        height: 100%;
        width: 8px;
        background-color: #409EFF;
        opacity: 0.6;
        border-radius: 2px;
        animation: mymove1 1.2s infinite ease-in-out;
    }
    .loading1>div:nth-child(1){
        animation-delay: -0.4s;
    }
    .loading1>div:nth-child(2){
        animation-delay: -0.3s;
    }
    .loading1>div:nth-child(3){
        animation-delay: -0.2s;
    }
    .loading1>div:nth-child(4){
        animation-delay: -0.1s;
    }
    .loading1>div:nth-child(5){
        animation-delay: -0s;
    }
    @keyframes mymove1 {
        0%, 40%, 100% {
            transform: scaleY(0.5);
        }    
        20% {
            transform: scaleY(1);
        }
    }

    .el-notification__content{
        color: #409EFF;
        font-weight: 800;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/index.vue